export enum ActionInstancePropertyType {
    /** Any text is allowed as the metadata value */
    Text = "Text",

    /** Only numbers are allowed as the metadata value */
    Numeric = "Numeric",

    /** Location type as the metadata value */
    Location = "Location",

    /** Date time as the metadata value */
    DateTime = "DateTime",

    /** Set (unique list) of strings as the metadata value */
    StringSet = "StringSet",

    /** List of Attachment as metadata value */
    AttachmentList = "AttachmentList"
}